const StereotypesActions = {
    // for the collection
    START_LOAD: "stereotypes/start-load",
    LOADED: "stereotypes/loaded",
    LOAD_ERROR: "stereotypes/load-error",
    // for an individual [synthetic] stereotype
    START_STEREOTYPE_LOAD: "stereotypes/start-stereotype-load",
    STEREOTYPE_LOADED: "stereotypes/stereotype-loaded",
    STEREOTYPE_LOAD_ERROR: "stereotypes/stereotype-load-error",
};

export default StereotypesActions;



// WEBPACK FOOTER //
// ./app/data/StereotypesActions.js